<template>
  <div v-if="loading" class="task__loader">
    <loader/>
  </div>
  <div v-else class="task__card">
    <div>
      <router-link class="task__medias" :to="{name: 'TaskDetails', params: {id: task_id}}">
        <img class="media__item" :src="thumbnail" />
      </router-link>

      <div class="task__project">
        {{ project.project_name }}
      </div>

      <!-- title -->
      <router-link class="task__title" :to="{name: 'TaskDetails', params: {id: task_id}}">
        {{ title }}
      </router-link>

      <!-- skills -->
      <div class="task__skills">
        <div class="skills__item" v-for="skill in taskSkills" :key="skill.skill_id">
          {{ skill.skill_name }}
        </div>
      </div>

      <div class="task__summary">
        <span class="summary__item" v-if="timeToEvent">
          <v-tooltip top>
            <v-icon slot="activator">access_time</v-icon>
            <span>Time to event</span>
          </v-tooltip>
          <span>{{ timeToEvent }}</span>
        </span>

        <span class="summary__item" v-if="length">
          <v-tooltip top>
            <v-icon slot="activator">timer</v-icon>
            <span>Effort duration</span>
          </v-tooltip>
          <span>{{ length }}</span>
        </span>
      </div>

      <div class="task_description" v-if="description">
        <vue-markdown :source="description" />
      </div>

      <!-- button -->
      <div class="task__buttons">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import get from 'lodash/get';
import VueMarkdown from 'vue-markdown';

import { getTaskDetails } from '@/api';
import { identifyFileType, FILE_TYPES } from '@/utils/file_type';


export default {
  components: { VueMarkdown },
  props: {
    task_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      task: {},
      project: {},
      taskDates: [],
      taskMedias: [],
      taskSkills: [],
      loading: false,
    };
  },
  computed: {
    noData() {
      return Object.keys(this.task).length === 0;
    },
    id() {
      return this.task.task_id;
    },
    title() {
      return this.task.task_name;
    },
    description() {
      return this.task.task_description;
    },
    thumbnail() {
      const imageMedia = this.taskMedias.find(
        media => identifyFileType(media.data_url) === FILE_TYPES.IMAGE,
      );
      return imageMedia && imageMedia.data_url;
    },
    length() {
      const minutes = parseInt(this.task.task_length, 10);
      return moment().add(minutes, 'minutes').fromNow(true);
    },
    timeToEvent() {
      const date = get(this.taskDates, '[0].task_date');
      if (!date) {
        return null;
      }

      const duration = moment(date);
      return duration.fromNow();
    },
  },
  methods: {
    fetchTask: async function _fetchTask() {
      if (!this.task_id) return;
      this.loading = true;
      const userToken = this.$store.getters['auth/userToken'];
      const { data } = await getTaskDetails(userToken, this.task_id);
      this.task = get(data, '[1].data.details[0].task_data', {});
      this.project = get(data, '[1].data.details[0].project_data', {});
      this.taskDates = get(data, '[1].data.details[0].tasks_dates', []);
      this.taskMedias = get(data, '[1].data.details[0].tasks_data', []);
      this.taskSkills = get(data, '[1].data.details[0].tasks_skills', []);
      this.loading = false;
    },
  },
  watch: {
    task_id: {
      immediate: true,
      handler: 'fetchTask',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.task__card {
  margin-top: 10px;
  max-width: 450px;
  height: 100%;
  padding: 20px 15px;
  box-shadow: 1px 1px 10px 0px rgba(224, 153, 153, 0.5);
  word-break: break-word;
}

.task__medias {
  display: flex;
  flex-direction: row;
  margin-left: -15px;
  margin-top: -20px;
  margin-right: -15px;
  margin-bottom: 10px;
  max-width: 450px;
}

.media__item {
  height: 50px;
  margin: 0;
  padding: 0;
  height: 90%;
  width: 100%;
}

.task__project {
  font-size: 14px;
  color: $light;
}

.task__title {
  clear: both;
  font-size: 24px;
  font-weight: bold;
  font-family: 'MuseoSans-500';
  line-height: 1.2;
  margin-top: 10px;
  text-decoration: none;
  color: initial;
}


.task__skills {
  margin-top: 5px;
  display: flex;
  direction: column;
  flex-wrap: wrap;
  // margin-top: 10px;
}

.skills__item {
  font-size: 10px;
  width: fit-content;
  height: fit-content;
  color: $blue;
  font-weight: 400;
  border: 1px solid $blue;
  padding: 3px 14px;
  border-radius: 24px;
  margin: 5px;
}

.skills__item:first-child {
  margin-left: 0;
}

.task__summary {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.summary__item {
  color: $light;
  margin-left: 15px;
}

.summary__item i {
  color: $light;
  font-size: 17px;
  padding-bottom: 4px;
}

.summary__item:first-child {
  margin-left: 0;
}

.task_description {
  margin-top: 10px;
}

.task__buttons {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.task__buttons .task__button {
  text-decoration: none;
  color: $blue;
}

.task__buttons .task__button:disabled, .task__buttons .task__button--primary:disabled {
  opacity: 0.50;
}

.task__buttons .task__button--primary  {
  text-decoration: none;
  color: $white;
  background: $primary;
  font-family: MuseoSans-900;
  text-align: center;
  border-radius: 24px;
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TaskCard.vue